var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { CHEVRON_DOWN_SVG } from "../assets";
import Collapse from "reactstrap/lib/Collapse";
var FAQ = function (props) {
    return (React.createElement("div", { className: "faq-container" },
        React.createElement("div", { className: "faq-inner" },
            React.createElement("div", { className: "faq-headline" },
                React.createElement("span", null, 'FAQs')),
            props.FAQItems.map(function (item, i) {
                return (React.createElement(FAQItem, { key: i, question: item.question, answer: item.answer }));
            }),
            React.createElement("div", { className: "faq-item" },
                React.createElement("div", { className: "question" },
                    React.createElement("span", null, "Still Have Questions?")),
                React.createElement("div", { className: "answer" },
                    React.createElement("span", null,
                        React.createElement("a", { href: "https://support.bpmsupreme.com", target: "_blank" }, "View More Billing & Support Questions")))))));
};
var FAQItem = /** @class */ (function (_super) {
    __extends(FAQItem, _super);
    function FAQItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    FAQItem.prototype.openToggle = function () {
        if (this.state.isOpen) {
            this.setState({ isOpen: false });
        }
        else {
            this.setState({ isOpen: true });
        }
    };
    FAQItem.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "faq-item" },
            React.createElement("div", { className: "question", onClick: function () { _this.openToggle(); } },
                React.createElement("span", null, this.props.question),
                React.createElement("img", { className: "icon " + (this.state.isOpen ? 'open' : ''), src: CHEVRON_DOWN_SVG, alt: 'arrow' })),
            React.createElement(Collapse, { isOpen: this.state.isOpen },
                React.createElement("div", { className: "answer" },
                    React.createElement("span", null, this.props.answer)))));
    };
    return FAQItem;
}(React.Component));
export { FAQItem };
export default FAQ;
//# sourceMappingURL=FAQ.js.map